import { render, staticRenderFns } from "./ShiftPatternDetails.vue?vue&type=template&id=9b4bac02"
import script from "./ShiftPatternDetails.vue?vue&type=script&lang=js"
export * from "./ShiftPatternDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports